import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Common from "us.common";
import { PlusOutlined } from "us.icons";
import { TemplateActions } from "components/EditorHome/Constants";
import { MoreOutlined } from "us.icons";
import { InView } from "react-intersection-observer";
import { $Avatar, $Image } from "us.common/components";
import { ItemMenu } from "./Components";
import {
  getTemplateActions,
  getTemplateIcon,
} from "components/EditorHome/Functions";
import { IGridItem } from "./interface";
const { $Popover, $Button, $Col, $DateTimeLabel } = Common.Components;

/**
 * @description - Template grid component.
 * @link Design Document -
 * @author Ishan Udyoga <ishanud@unicorn-solutions.com>
 * @since 11/09/2022
 */
const GridItem: React.FC<IGridItem> = (props) => {
  const { template, onCallAction } = props;
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const {
    templateName,
    templateId,
    previewImage,
    description,
    outPutFormat,
    lastUpdatedDate,
    createdDate,
    groupName,
    categoryName,
  } = template;

  return (
    <$Col key={templateName + templateId} span={6}>
      {templateId == 0 && (
        <InView
          as="div"
          onChange={(inView: any) =>
            !inView
              ? document
                  .getElementById("new-template-btn")
                  ?.classList?.add("active")
              : document
                  .getElementById("new-template-btn")
                  ?.classList?.remove("active")
          }
          className="template-item ti-create-new"
          onClick={() => onCallAction(TemplateActions.CREATE_NEW)}
        >
          <div className="template-default-item">
            <h3 className="mb-1">
              <PlusOutlined />
            </h3>
            <h3>
              {t("US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.CREATE_NEW_TEMPLATE")}
            </h3>
          </div>
        </InView>
      )}
      {templateId !== 0 && (
        <div className="template-item">
          <div
            className="template-item-content"
            onClick={() => onCallAction(TemplateActions.EDIT)}
          >
            {previewImage ? (
              <img
                src={previewImage}
                alt="Logo"
                style={{
                  width: "100%",
                }}
                draggable={false}
              />
            ) : (
              <$Image
                src={require("us.icons/svg/template_placeholder.svg")}
                preview={false}
              />
            )}
            <div className="template-grid-description font-sm">
              {description}
            </div>
          </div>
          <div className="template-item-title d-flex p-2">
            <div
              className="d-flex"
              onClick={() => onCallAction(TemplateActions.EDIT)}
            >
              <div className="d-flex align-items-start">
                <$Avatar
                  className="template-icon"
                  icon={getTemplateIcon(outPutFormat)}
                />
              </div>
              <div className="pl-2">
                <span className="templateName">{template.templateName}</span>
                {createdDate && (
                  <div className="text-muted font-sm">
                    {`${t(
                      "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.CREATED_DATE"
                    )}: `}
                    <$DateTimeLabel value={createdDate} />
                  </div>
                )}
                {lastUpdatedDate && (
                  <div className="text-muted font-sm">
                    {`${t(
                      "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.LAST_MODIFIED_DATE"
                    )}: `}
                    <$DateTimeLabel value={lastUpdatedDate} />
                  </div>
                )}
              </div>
            </div>
            <div className="template-grid-actions">
              <$Popover
                placement="bottomLeft"
                trigger="click"
                open={open}
                content={
                  <ItemMenu
                    record={template}
                    onCallAction={(actionType: TemplateActions) => {
                      onCallAction(actionType);
                      setOpen(false);
                    }}
                    actions={getTemplateActions(groupName, categoryName)}
                  />
                }
                onOpenChange={(newOpen: boolean) => setOpen(newOpen)}
                destroyTooltipOnHide
              >
                <$Button
                  data-testid="popover-btn"
                  icon={<MoreOutlined />}
                  size="small"
                  type="link"
                />
              </$Popover>
            </div>
          </div>
        </div>
      )}
    </$Col>
  );
};

export default GridItem;
